export default __webpack_public_path__ + "static/media/img_5.1c5267e0.svg";